import api from '../../utils/api'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormSizeGrid from './Form/FormSizeGrid'

function EditSizeGrid({id , btCancelAction, handleOnSuccess}){
    const [sizeGrid, setSizeGrid] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    /* const {id} = useParams() */
    
    const {setFlashMessage} = useFlashMessage()
    const navigate = useNavigate()
console.log(sizeGrid)
    useEffect(() => {

        api.get(`/sizeGrid/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
            
        }).then((response) => {
            
            setSizeGrid(response.data.sizeGrid)
        })
    }, [token, id])

    async function updateSizeGrid(sizeGrid) {
        let msgType = 'success'
        
        
        const data = await api.patch(`sizeGrid/${sizeGrid._id}`, sizeGrid, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {
            
            return response.data
        }).catch((err) => {
            
            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            /* navigate('/sizeGrid') */
            }

    }


    return (
        sizeGrid.name && (
            <FormSizeGrid title="Editar Grade" handleSubmit={updateSizeGrid} btnText="Salvar" btCancelAction={btCancelAction} sizeGridData={sizeGrid} gridData={sizeGrid.grid} />
        )
    )
}

export default EditSizeGrid